/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * data security, extended fields are encrypted using the specified algorithm
   */
  security?: Record<string, 'md5' | 'sha1' | 'aes' | 'des'>;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
  /** only in axios interceptor config*/
  loading: boolean;
  showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(
  configs: IRequestConfig,
  resolve: (p: any) => void,
  reject: (p: any) => void
): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(
  method: string,
  contentType: string,
  url: string,
  options: any
): IRequestConfig {
  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url,
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType,
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class RightsService {
  /**
   *
   */
  static rightsControllerGetProfilesRights(
    options: IRequestOptions = {}
  ): Promise<ProfilesRights[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rights/profilesRights';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static rightsControllerGetUserUnitaryRights(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rights/userUnitaryRights';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static rightsControllerGetAuthorizedModifiedProfiles(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rights/authorizedModifiedProfiles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static rightsControllerGetRights(options: IRequestOptions = {}): Promise<Right[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rights';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static rightsControllerAddRights(
    params: {
      /** requestBody */
      body?: AddRightsParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Right> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rights';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static rightsControllerUpdateRights(
    params: {
      /** requestBody */
      body?: UpdateRightsParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rights';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static rightsControllerDeleteRights(
    params: {
      /**  */
      consultantSiid: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rights/{consultantSiid}';
      url = url.replace('{consultantSiid}', params['consultantSiid'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class HomeEditionService {
  /**
   *
   */
  static homeEditionControllerGetHomePageConfig(
    options: IRequestOptions = {}
  ): Promise<HomePageConfig> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/home-page-format';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerUpdateHomePageConfig(
    params: {
      /** requestBody */
      body?: UpdateHomePageConfigParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/home-page-format';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerGetAllAppNews(options: IRequestOptions = {}): Promise<AllAppNews> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/all-app-news';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerGetAppNews(options: IRequestOptions = {}): Promise<AppNews[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-news';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerAddAppNews(
    params: {
      /** requestBody */
      body?: AddAppNewsParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-news';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerUpdateAppNews(
    params: {
      /** requestBody */
      body?: UpdateAppNewsParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-news';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerDeleteAppNews(
    params: {
      /** requestBody */
      body?: DeleteAppNewsParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-news';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerUpdateAppNewsOrder(
    params: {
      /** requestBody */
      body?: UpdateAppNewsOrderParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-news-order';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerMoveAppNewsToArchivedOrNot(
    params: {
      /** requestBody */
      body?: MoveAppNewsToArchivedOrNotParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-news-archive-or-not';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerGetAppDetails(options: IRequestOptions = {}): Promise<AppDetail[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-details';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerAddAppDetails(
    params: {
      /** requestBody */
      body?: AddAppDetailsParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DBAppDetails[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-details';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerUpdateAppDetails(
    params: {
      /** requestBody */
      body?: UpdateAppDetailsParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-details';

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static homeEditionControllerDeleteAppDetails(
    params: {
      /** requestBody */
      body?: DeleteAppDetailsParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/home-edition/app-details';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class SkillsManagementCentersService {
  /**
   *
   */
  static skillsManagementCentersControllerGetCgCs(
    options: IRequestOptions = {}
  ): Promise<CGCWithUnits[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/skillsManagementCenters';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static skillsManagementCentersControllerGetUnitsWithoutCgCs(
    params: {
      /**  */
      limit: number;
      /**  */
      offset: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UnitsWithTotalCount> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/skillsManagementCenters/unitsWithoutCGCs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { limit: params['limit'], offset: params['offset'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static skillsManagementCentersControllerAddUnitsToCgc(
    params: {
      /** requestBody */
      body?: PutUnitsToCGCParam;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/skillsManagementCenters/unitsToCGC';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static skillsManagementCentersControllerOverrideUnitsToCgc(
    params: {
      /** requestBody */
      body?: PutUnitsToCGCParam;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/skillsManagementCenters/overrideUnitsToCGC';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static skillsManagementCentersControllerReassignUnitToCgc(
    params: {
      /** requestBody */
      body?: ReassignUnitToCGCParam;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/skillsManagementCenters/reassignUnitToCGC';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AgenciesService {
  /**
   *
   */
  static agenciesControllerGetConsultantAgencies(
    options: IRequestOptions = {}
  ): Promise<AgenciesWithBrandCodes> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agencies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static agenciesControllerGetAgenciesByBrandCode(
    params: {
      /**  */
      brandCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgencyDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agencies/{brandCode}/all';
      url = url.replace('{brandCode}', params['brandCode'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static agenciesControllerGetCompanies(
    params: {
      /**  */
      agencyId: string;
      /** requestBody */
      body?: SocietyStatusDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Company[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agencies/{agencyId}/companies';
      url = url.replace('{agencyId}', params['agencyId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static agenciesControllerGetQualifications(
    params: {
      /**  */
      agencyId: string;
      /**  */
      companyId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Qualification[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agencies/{agencyId}/companies/{companyId}/qualifications';
      url = url.replace('{agencyId}', params['agencyId'] + '');
      url = url.replace('{companyId}', params['companyId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static agenciesControllerGetConfig(
    params: {
      /**  */
      agencyId: string;
      /**  */
      brandCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AgencyConfigDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agencies/{agencyId}';
      url = url.replace('{agencyId}', params['agencyId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { brandCode: params['brandCode'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static agenciesControllerUpdateConfig(
    params: {
      /**  */
      agencyId: string;
      /**  */
      brandCode: string;
      /** requestBody */
      body?: AgencyConfigDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agencies/{agencyId}';
      url = url.replace('{agencyId}', params['agencyId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { brandCode: params['brandCode'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static agenciesControllerGetBrandsAvailable(options: IRequestOptions = {}): Promise<BrandDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agencies/brands/brand-codes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class CalendarService {
  /**
   *
   */
  static calendarControllerGetCalendars(
    params: {
      /**  */
      agencyId: string;
      /**  */
      brandCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CalendarEntity[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/calendar/{agencyId}';
      url = url.replace('{agencyId}', params['agencyId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { brandCode: params['brandCode'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static calendarControllerAddCalendar(
    params: {
      /**  */
      agencyId: string;
      /**  */
      brandCode: string;
      /** requestBody */
      body?: CalendarDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/calendar/{agencyId}';
      url = url.replace('{agencyId}', params['agencyId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { brandCode: params['brandCode'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static calendarControllerEditCalendar(
    params: {
      /**  */
      agencyId: string;
      /**  */
      calendarObjectId: string;
      /** requestBody */
      body?: CalendarDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/calendar/{agencyId}/{calendarObjectId}';
      url = url.replace('{agencyId}', params['agencyId'] + '');
      url = url.replace('{calendarObjectId}', params['calendarObjectId'] + '');

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static calendarControllerRemoveCalendar(
    params: {
      /**  */
      agencyId: string;
      /**  */
      calendarObjectId: string;
      /**  */
      brandCode: string;
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/calendar/{agencyId}/{calendarObjectId}';
      url = url.replace('{agencyId}', params['agencyId'] + '');
      url = url.replace('{calendarObjectId}', params['calendarObjectId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { brandCode: params['brandCode'] };

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CustomLinksService {
  /**
   *
   */
  static customLinksControllerGetAll(
    options: IRequestOptions = {}
  ): Promise<CustomLinksResultsDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/custom-links';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static customLinksControllerCreateLink(
    params: {
      /** requestBody */
      body?: OfferInfoDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/custom-links';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static customLinksControllerGetOne(
    params: {
      /**  */
      link: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CustomLinksResultsDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/custom-links/{link}';
      url = url.replace('{link}', params['link'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static customLinksControllerUpdateLink(
    params: {
      /**  */
      link: string;
      /** requestBody */
      body?: UpdateLinkDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/custom-links/{link}';
      url = url.replace('{link}', params['link'] + '');

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static customLinksControllerGetExistingLink(
    params: {
      /** requestBody */
      body?: LinkExistsDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/custom-links/existing';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class RoutingsService {
  /**
   *
   */
  static routingsControllerCreateRouting(
    params: {
      /** requestBody */
      body?: CreateRoutingInfoBody;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/routings';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static routingsControllerUpdateRouting(
    params: {
      /** requestBody */
      body?: UpdateRoutingInfoBody;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/routings';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static routingsControllerDeleteRouting(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/routings/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static routingsControllerGetRouting(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoutingInfos> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/routings/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static routingsControllerSearchRoutings(
    params: {
      /** requestBody */
      body?: GetRoutingsBody;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SearchRoutingInfosResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/routings/search';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static routingsControllerFetchUniqueColumnValues(
    params: {
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoutingColumnUniqueValues> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/routings/column-values';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static routingsControllerFetchAgencies(
    params: {
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/routings/agencies';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class MbapiAdminService {
  /**
   *
   */
  static mbapiAdminControllerCreateUser(
    params: {
      /** requestBody */
      body?: CreateUserParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mbapi-admin/users';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static mbapiAdminControllerAddUsersOnRoute(
    params: {
      /** requestBody */
      body?: AddUsersToRouteParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mbapi-admin/routes';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static mbapiAdminControllerRemoveUsersFromRoute(
    params: {
      /** requestBody */
      body?: RemoveUsersFromRouteParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mbapi-admin/routes';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static mbapiAdminControllerGetAllRoutes(
    options: IRequestOptions = {}
  ): Promise<GetAllRoutesResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/mbapi-admin/routes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class OnCallCentersService {
  /**
   *
   */
  static onCallCentersControllerFetchOnCallCenters(
    options: IRequestOptions = {}
  ): Promise<OnCallCenterDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/on-call-centers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static onCallCentersControllerAddAgenciesToOnCallCenter(
    params: {
      /** requestBody */
      body?: UpdateOnCallCenterBody;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/on-call-centers/add';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static onCallCentersControllerDeleteAgenciesFromOnCallCenter(
    params: {
      /** requestBody */
      body?: UpdateOnCallCenterBody;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/on-call-centers/remove';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static onCallCentersControllerGetOnCallCenter(
    params: {
      /**  */
      onCallCenterId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OnCallCenterDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/on-call-centers/{onCallCenterId}';
      url = url.replace('{onCallCenterId}', params['onCallCenterId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class CronJobsService {
  /**
   *
   */
  static cronJobsControllerFetchCronJobConfigs(
    options: IRequestOptions = {}
  ): Promise<CronJobConfig[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/cron-jobs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static cronJobsControllerGetCronJobDetails(
    params: {
      /**  */
      cronJob: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CronJobDetails> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/cron-jobs/{cronJob}';
      url = url.replace('{cronJob}', params['cronJob'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static cronJobsControllerUpdateCronJobConfig(
    params: {
      /**  */
      cronJob: string;
      /** requestBody */
      body?: UpdateCronJobConfigParams;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/cron-jobs/{cronJob}';
      url = url.replace('{cronJob}', params['cronJob'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static cronJobsControllerRunCronJobManually(
    params: {
      /**  */
      cronJob: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/cron-jobs/{cronJob}/run';
      url = url.replace('{cronJob}', params['cronJob'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export interface ProfilesRights {
  /**  */
  profile: RightsProfile;

  /**  */
  unitaryRights: UnitaryRight[];
}

export interface Right {
  /**  */
  profile: RightsProfile;

  /**  */
  consultantSiid: string;

  /**  */
  consultantName?: string;

  /**  */
  consultantFirstName?: string;

  /**  */
  consultantEmail?: string;
}

export interface AddRightsParams {
  /**  */
  profile: Profile;

  /**  */
  consultantEmail: string;
}

export interface UpdateRightsParams {
  /**  */
  profile: Profile;

  /**  */
  consultantSiid: string;
}

export interface HomePageConfig {
  /**  */
  homePageFormat: HomePageFormat;

  /**  */
  homePageTitle: string;
}

export interface UpdateHomePageConfigParams {
  /**  */
  homePageFormat: HomePageFormat;

  /**  */
  homePageTitle: string;
}

export interface OSMConsultantModelDtoFullConsultantDto {
  /**  */
  name?: string;

  /**  */
  firstName?: string;

  /**  */
  mobilePhoneNumber?: string;

  /**  */
  phone?: string;

  /**  */
  email?: string;
}

export interface AppNews {
  /**  */
  app?: RandstadAppEnum;

  /**  */
  id?: string;

  /**  */
  createdAt?: Date;

  /**  */
  updatedAt?: Date;

  /**  */
  lastUpdateConsultant?: OSMConsultantModelDtoFullConsultantDto;

  /**  */
  version?: string;

  /**  */
  newsTitle?: string;

  /**  */
  description?: string;

  /**  */
  order?: number;
}

export interface AllAppNews {
  /**  */
  notArchived: AppNews[];

  /**  */
  archived: AppNews[];
}

export interface AddAppNewsParams {
  /**  */
  appNews: object;
}

export interface UpdateAppNewsParams {
  /**  */
  isArchived: boolean;

  /**  */
  appNews: AppNews;
}

export interface DeleteAppNewsParams {
  /**  */
  isArchived: boolean;

  /**  */
  appNewsId: string;
}

export interface UpdateAppNewsOrderParams {
  /**  */
  isArchived: boolean;

  /**  */
  appNewsToUpdate: AppNews[];
}

export interface MoveAppNewsToArchivedOrNotParams {
  /**  */
  toArchived: boolean;

  /**  */
  appNewsId: string;
}

export interface AppDetail {
  /**  */
  app: RandstadAppEnum;

  /**  */
  description?: string;

  /**  */
  order?: number;

  /**  */
  isHighlighted?: boolean;
}

export interface AddAppDetailsParams {
  /**  */
  appDetails: AppDetail[];
}

export interface DBAppDetails {}

export interface UpdateAppDetailsParams {
  /**  */
  appDetails: AppDetail[];
}

export interface DeleteAppDetailsParams {
  /**  */
  app: RandstadAppEnum;
}

export interface Unit {
  /**  */
  id: string;

  /**  */
  label: string;
}

export interface CGCWithUnits {
  /**  */
  id: string;

  /**  */
  label: string;

  /**  */
  units: Unit[];
}

export interface UnitsWithTotalCount {
  /**  */
  totalCount: number;

  /**  */
  units: Unit[];
}

export interface PutUnitsToCGCParam {
  /**  */
  cgcId: string;

  /**  */
  unitIds: string[];
}

export interface ReassignUnitToCGCParam {
  /**  */
  unitId: string;

  /**  */
  previousCgcId: string;

  /**  */
  newCgcId: string;
}

export interface Agencies {
  /**  */
  brandCode?: string;

  /**  */
  agencies: string[];
}

export interface AgenciesWithBrandCodes {
  /**  */
  defaultAgency?: string;

  /**  */
  agencies: Agencies[];
}

export interface AgencyDto {
  /**  */
  agencyId: string;

  /**  */
  brandCode: string;
}

export interface SocietyStatusDto {
  /**  */
  societyStatus: SocietyStatus;
}

export interface Company {
  /**  */
  companyId: string;

  /**  */
  companySiret: string;

  /**  */
  companyName: string;
}

export interface Qualification {
  /**  */
  qualificationId: string;

  /**  */
  qualificationLabel: string;
}

export interface AgencyCoordsDto {
  /**  */
  email?: string;

  /**  */
  phoneNumber?: string;
}

export interface AgencyConfigDto {
  /**  */
  coords?: AgencyCoordsDto;

  /**  */
  brand?: string;
}

export interface BrandDto {
  /**  */
  brands: string[];
}

export interface CalendarEntity {
  /**  */
  id: string;

  /**  */
  title: string;

  /**  */
  calendarIdentification: string;

  /**  */
  delegatedEmail: string;

  /**  */
  agencyId: string;

  /**  */
  agencyBrand?: string;
}

export interface CalendarDto {
  /**  */
  title: string;

  /**  */
  calendarIdentification: string;

  /**  */
  delegatedEmail: string;
}

export interface CustomLinksResultsDto {
  /**  */
  offerStatus: OfferStatus;

  /**  */
  id: string;

  /**  */
  agencyId: string;

  /**  */
  qualificationId: string;

  /**  */
  qualificationLabel: string;

  /**  */
  companyId: string;

  /**  */
  companySiret: string;

  /**  */
  companyName: string;

  /**  */
  calendarId?: string;

  /**  */
  offerLink: string;

  /**  */
  agencyBrand: string;
}

export interface OfferInfoDto {
  /**  */
  agencyId: string;

  /**  */
  qualificationId: string;

  /**  */
  qualificationLabel: string;

  /**  */
  companyId: string;

  /**  */
  companySiret: string;

  /**  */
  companyName: string;

  /**  */
  calendarId?: string;
}

export interface UpdateLinkDto {
  /**  */
  calendarId?: string;
}

export interface LinkExistsDto {
  /**  */
  agencyId: string;

  /**  */
  companyId: string;

  /**  */
  qualificationId: string;
}

export interface CreateRoutingInfoBody {
  /**  */
  source: AppelMedicalEventSource;

  /**  */
  agencyId: string;

  /**  */
  brandCode: string;

  /**  */
  siret: string;

  /**  */
  service?: string;

  /**  */
  clientName: string;

  /**  */
  qualification: string;
}

export interface UpdateRoutingInfoBody {
  /**  */
  source: AppelMedicalEventSource;

  /**  */
  routingId: string;

  /**  */
  agencyId?: string;

  /**  */
  brandCode?: string;

  /**  */
  string?: string;

  /**  */
  siret?: string;
}

export interface FetchRoutingsSort {
  /**  */
  sortCriteria: FetchRoutingsSortCriteria;

  /**  */
  sortType: SortTypeEnum;
}

export interface GetRoutingsBody {
  /**  */
  source: AppelMedicalEventSource;

  /**  */
  agencyIds?: string[];

  /**  */
  brandCodes?: string[];

  /**  */
  sirets?: string[];

  /**  */
  services?: string[];

  /**  */
  clientNames?: string[];

  /**  */
  qualifications?: string[];

  /**  */
  globalFilter?: string;

  /**  */
  sort?: FetchRoutingsSort;

  /**  */
  page?: number;

  /**  */
  limit?: number;
}

export interface RoutingInfos {
  /**  */
  source: AppelMedicalEventSource;

  /**  */
  routingId: string;

  /**  */
  clientName: string;

  /**  */
  qualification: string;

  /**  */
  brandCode?: string;

  /**  */
  service?: string;

  /**  */
  siret?: string;

  /**  */
  agencyId?: string;

  /**  */
  updatedAt: string;
}

export interface SearchRoutingInfosResponse {
  /**  */
  count: number;

  /**  */
  routings: RoutingInfos[];
}

export interface RoutingColumnUniqueValues {
  /**  */
  clientNames: string[];

  /**  */
  qualifications: string[];

  /**  */
  brands: string[];

  /**  */
  agenciesIds: string[];

  /**  */
  sirets: string[];

  /**  */
  services: string[];
}

export interface CreateUserParams {
  /**  */
  username: string;

  /**  */
  password: string;
}

export interface AddUsersToRouteParams {
  /**  */
  method: RouteMethod;

  /**  */
  path: string;

  /**  */
  usernames: string[];
}

export interface RemoveUsersFromRouteParams {
  /**  */
  method: RouteMethod;

  /**  */
  path: string;

  /**  */
  usernames: string[];
}

export interface Route {
  /**  */
  method: RouteMethod;

  /**  */
  path: string;

  /**  */
  usernames: string[];
}

export interface GetAllRoutesResponse {
  /**  */
  users: string[];

  /**  */
  routes: Route[];
}

export interface OnCallCenterAgencyDto {
  /**  */
  agencyId: string;

  /**  */
  brandCode: string;
}

export interface OnCallCenterDto {
  /**  */
  onCallCenterId: string;

  /**  */
  agencies: OnCallCenterAgencyDto[];

  /**  */
  brandCode: string;
}

export interface UpdateOnCallCenterBody {
  /**  */
  onCallCenterId: string;

  /**  */
  agencies: OnCallCenterAgencyDto[];
}

export interface CronJobConfig {
  /**  */
  cronJobId: string;

  /**  */
  cronTime: string;

  /**  */
  enabled: boolean;

  /**  */
  lastExecution?: Date;
}

export interface CronJobLog {
  /**  */
  level: CronJobLogLevel;

  /**  */
  message?: object;

  /**  */
  trace?: string;
}

export interface CronJobExecution {
  /**  */
  mode: CronJobExecutionMode;

  /**  */
  executionId: string;

  /**  */
  logs: CronJobLog[];

  /**  */
  createdAt: Date;

  /**  */
  updatedAt: Date;
}

export interface CronJobDetails {
  /**  */
  cronJobId: string;

  /**  */
  cronTime: string;

  /**  */
  enabled: boolean;

  /**  */
  executions: CronJobExecution[];

  /**  */
  currentExecutionId?: string;
}

export interface UpdateCronJobConfigParams {
  /**  */
  cronTime: string;

  /**  */
  enabled: boolean;
}

export enum RightsProfile {
  'SUPERADMIN' = 'SUPERADMIN',
  'ADMIN_CGC' = 'ADMIN_CGC',
  'EDITOR_CGC' = 'EDITOR_CGC',
  'ADMIN_HOME_EDITION' = 'ADMIN_HOME_EDITION',
  'EDITOR_HOME_EDITION' = 'EDITOR_HOME_EDITION',
  'EDITOR_ROUTING' = 'EDITOR_ROUTING',
  'EDITOR_ON_CALL_CENTER' = 'EDITOR_ON_CALL_CENTER',
  'EDITOR_CRON_JOBS' = 'EDITOR_CRON_JOBS',
  'ADMIN_MBAPI' = 'ADMIN_MBAPI',
}

export enum UnitaryRight {
  'ADD_ADMIN' = 'ADD_ADMIN',
  'ADD_ADMIN_CGC' = 'ADD_ADMIN_CGC',
  'EDIT_CGC' = 'EDIT_CGC',
  'EDIT_QUALIFICATIONS' = 'EDIT_QUALIFICATIONS',
  'ADD_ADMIN_HOME_EDITION' = 'ADD_ADMIN_HOME_EDITION',
  'EDIT_HOME_EDITION' = 'EDIT_HOME_EDITION',
  'EDIT_ROUTING' = 'EDIT_ROUTING',
  'EDIT_ON_CALL_CENTER' = 'EDIT_ON_CALL_CENTER',
  'EDIT_CRON_JOBS' = 'EDIT_CRON_JOBS',
  'ADMIN_MBAPI' = 'ADMIN_MBAPI',
}

export enum Profile {
  'SUPERADMIN' = 'SUPERADMIN',
  'ADMIN_CGC' = 'ADMIN_CGC',
  'EDITOR_CGC' = 'EDITOR_CGC',
  'ADMIN_HOME_EDITION' = 'ADMIN_HOME_EDITION',
  'EDITOR_HOME_EDITION' = 'EDITOR_HOME_EDITION',
  'EDITOR_ROUTING' = 'EDITOR_ROUTING',
  'EDITOR_ON_CALL_CENTER' = 'EDITOR_ON_CALL_CENTER',
  'EDITOR_CRON_JOBS' = 'EDITOR_CRON_JOBS',
  'ADMIN_MBAPI' = 'ADMIN_MBAPI',
}

export enum HomePageFormat {
  'BIG_IMAGE' = 'BIG_IMAGE',
  'SMALL_IMAGE' = 'SMALL_IMAGE',
  'NO_IMAGE' = 'NO_IMAGE',
}

export enum RandstadAppEnum {
  'EDP' = 'EDP',
  'FLASH' = 'FLASH',
  'RECRUTLIVE' = 'RECRUTLIVE',
  'PUZZLE' = 'PUZZLE',
  'SATISFACTION' = 'SATISFACTION',
  'TDP' = 'TDP',
  'PIGE' = 'PIGE',
  'SCOPE' = 'SCOPE',
  'IT' = 'IT',
  'BDP' = 'BDP',
  'CUSTOM_RANDY' = 'CUSTOM_RANDY',
  'PULSE' = 'PULSE',
}

export enum SocietyStatus {
  'All' = 'All',
  'Prospect' = 'Prospect',
  'Client' = 'Client',
}

export enum OfferStatus {
  'ACTIVE' = 'ACTIVE',
  'INACTIVE' = 'INACTIVE',
}

export enum AppelMedicalEventSource {
  'HUBLO' = 'HUBLO',
  'ARTEMIHS' = 'ARTEMIHS',
  'PEOPULSE' = 'PEOPULSE',
}

export enum FetchRoutingsSortCriteria {
  'routing.clientName' = 'routing.clientName',
  'routing.qualification' = 'routing.qualification',
  'routing.brandCode' = 'routing.brandCode',
  'routing.siret' = 'routing.siret',
  'routing.service' = 'routing.service',
  'agency.id' = 'agency.id',
}

export enum SortTypeEnum {
  'ASC' = 'ASC',
  'DESC' = 'DESC',
}

export enum RouteMethod {
  'GET' = 'GET',
  'POST' = 'POST',
  'DELETE' = 'DELETE',
  'PUT' = 'PUT',
  'PATCH' = 'PATCH',
}

export enum CronJobExecutionMode {
  'SCHEDULED' = 'SCHEDULED',
  'MANUAL' = 'MANUAL',
  'TESTING' = 'TESTING',
}

export enum CronJobLogLevel {
  'INFO' = 'INFO',
  'WARN' = 'WARN',
  'DEBUG' = 'DEBUG',
  'ERROR' = 'ERROR',
  'VERBOSE' = 'VERBOSE',
}
